module.exports = __webpack_public_path__ + "img/2025-11-17c_6.2c779ab9.jpg";